import { render } from "./DataNotFound.vue?vue&type=template&id=5d569fb8"
const script = {}
script.render = render

export default script